import axios from 'axios'

import { apiUrl } from '@/config/env'

/**
 * Instancia sin interceptores de sesión, reservada a los endpoints que
 * establecen o rotan la sesión (login, refresh). Usarla en el cliente
 * principal crearía un ciclo: un 401 en /auth/refresh dispararía otro refresh.
 */
export const rawClient = axios.create({
  baseURL: apiUrl,
  timeout: 15_000,
})
